import React from "react";
import { Box } from "@showitinc/showit-wc";
import styles from "./Toolbar.module.css";
import ToolbarLeft from "./ToolbarLeft";
import ToolbarMiddle from "./ToolbarMiddle";
import ToolbarRight from "./ToolbarRight";

const Toolbar = () => (
  <Box id="top-toolbar" d="flex" pr="2" align="center" justify="between" className={styles.toolbar}>
    <ToolbarLeft />
    <ToolbarMiddle />
    <ToolbarRight />
  </Box>
);

export default Toolbar;
